import { Injectable, Inject } from '@angular/core';
import * as signalR from "@aspnet/signalr";

@Injectable({
  providedIn: 'root'
})
export class SignalRService {

  private uri: string;
  private hubConnection: signalR.HubConnection

  constructor(@Inject('BASE_URL') baseUrl: string) {
    this.uri = baseUrl.lastIndexOf('/') == baseUrl.length - 1 ? baseUrl.substring(0, baseUrl.length - 1) : baseUrl;
  }

  public StartConnection = (callback, hubPath) => {

    var url = this.uri;
    this.hubConnection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Debug)
      .withUrl(url +'/api' + hubPath, {
        transport: signalR.HttpTransportType.WebSockets
      }).build();



    this.hubConnection
      .start()
      .then(() => console.log('Connection started ' + hubPath))
      .catch(
        function (err) {
          console.log('Error while starting connection: ' + err)
        }
    )

    var hubName = hubPath.replace('/', '');

    this.hubConnection.on(hubName, (data) => {
      callback(data);
    });
  }

  public Stop = () => {
  if (this.hubConnection) {
    this.hubConnection.stop();
    }
  }

  public IsSupported = function () {
    return 'WebSocket' in window || 'MozWebSocket' in window;
  };
}
